import moment from 'moment'
import config from '@/config'

const EMPTY_PROP = '–'
const DATE_FORMAT = config.dateFormat.client

const DeliveryDateCell = (props) => {
  const { value, data } = props
  if (!value || !moment(value).isValid()) {
    return EMPTY_PROP
  }

  const deliveryDate = moment(value).format(DATE_FORMAT)

  if (data?.deliveryDateFrom && moment(data.deliveryDateFrom).isValid()) {
    const deliveryDateFrom = moment(data.deliveryDateFrom).format(DATE_FORMAT)
    if (deliveryDateFrom !== deliveryDate) {
      return `${deliveryDateFrom} - ${deliveryDate}`
    }
  }

  return deliveryDate
}

export default DeliveryDateCell
